export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/equinix4-71d429d248734f9ef1746402bb7e20ae.png";